import React, { useState, useEffect } from 'react';
import { Scale, FileText } from 'lucide-react';
import { legalFrameworkService } from '../services/api';

function LegalFramework() {
  const [legalFramework, setLegalFramework] = useState({
    title: 'چهارچوب قانونی',
    content: '',
    image: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLegalFramework = async () => {
      try {
        const response = await legalFrameworkService.get();
        setLegalFramework(response.data);
      } catch (error) {
        console.error('Error fetching legal framework:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchLegalFramework();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">چهارچوب قانونی</h1>
          <p className="text-xl text-blue-100">قوانین و مقررات نشریه مجری</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        {legalFramework.image && (
          <div className="mb-8">
            <img
              src={legalFramework.image}
              alt="چهارچوب قانونی"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        )}

        <div className="bg-white rounded-xl shadow-md p-8">
          <div className="flex items-center gap-3 mb-6">
            <Scale className="text-blue-700" size={32} />
            <h2 className="text-3xl font-bold text-gray-900">چارچوب قانونی نشریه</h2>
          </div>

          {legalFramework.content ? (
            <div className="prose max-w-none">
              <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                {legalFramework.content}
              </div>
            </div>
          ) : (
            <div className="text-center py-12 text-gray-500">
              <FileText size={48} className="mx-auto mb-4 opacity-30" />
              <p>اطلاعاتی برای نمایش وجود ندارد</p>
              <p className="text-sm mt-2">لطفاً از پنل ادمین محتوای چهارچوب قانونی را وارد کنید</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LegalFramework;
